<div *ngIf="!isLoading">
    <hr>

    <div style="margin-bottom: 5px;">
        <img src="../../assets/img/UMA-multi-match-header.jpg" alt="Banner"
            style="width: 100%; display: block; margin: 0; padding: 0;">
    </div>
    <h2 style="text-align: center;">{{formatPhoneNumber(phoneNumber)}}</h2>

    <table class="multi-match-table">
        <caption>Multiple Match Results</caption>
        <thead>
            <tr>
                <th>Name</th>
                <th>Student ID</th>
                <th>Student #</th>
                <th>School Status</th>
                <th>Campus</th>
                <th>Lead Date</th>
            </tr>
        </thead>
        <tbody class="table-body">
            <tr *ngFor="let student of filteredStudentData; let i = index;" class="selectionRow" (click)="studentSelected(i)" (keypress)="studentSelected(i)" [ngClass]="{'selected': i === selectedItem}">
                <td>{{student.lastName}}, {{student.firstName}}</td>
                <td>{{student.id}}</td>
                <td>{{student.studentNumber}}</td>
                <td>{{student.schoolStatus?.description}}</td>
                <td>{{student.campus?.code}}</td>
                <td>{{formatDate(student.leadDate)}}</td>
            </tr>
        </tbody>
    </table>

    <gux-button accent="{{buttonType}}" class="call-button" [disabled]="selectedItem === -1 || selectButtonDisable" (click)="selectButtonClicked()" (keypress)="selectButtonClicked()">
        <span>Select</span>
    </gux-button>
</div>